import { render, staticRenderFns } from "./PDFDefaultContent.vue?vue&type=template&id=48237946&scoped=true&"
import script from "./PDFDefaultContent.vue?vue&type=script&lang=js&"
export * from "./PDFDefaultContent.vue?vue&type=script&lang=js&"
import style0 from "./PDFDefaultContent.vue?vue&type=style&index=0&id=48237946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48237946",
  null
  
)

export default component.exports